import { createContext, ReactNode, useContext } from 'react';

interface SidenavContextValue {
  collapsed: boolean;
}

const SidenavContext = createContext<SidenavContextValue | undefined>(undefined);

/** Reads sidenav collapsed state. */
export function useSidenavContext() {
  const context = useContext(SidenavContext);
  if (context === undefined) {
    throw new Error('useSidenavContext must be used within SidenavContextProvider');
  }

  return context;
}

/** Provides collapsed state to sidenav descendants. */
export function SidenavContextProvider({
  collapsed,
  children,
}: {
  collapsed: boolean;
  children: ReactNode;
}) {
  return <SidenavContext.Provider value={{ collapsed }}>{children}</SidenavContext.Provider>;
}
